import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=3f3c270f&scoped=true&"
import script from "./billDetails.vue?vue&type=script&lang=js&"
export * from "./billDetails.vue?vue&type=script&lang=js&"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=3f3c270f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c270f",
  null
  
)

export default component.exports